import React from 'react';

const PageHead = ({ eyebrow, title }) => (
  <div className="pt-14 md:pt-20 pb-6 fade-up">
    {eyebrow && (
      <div className="dot-eyebrow mono uppercase tracking-[0.2em] text-[11px] text-ink-mute mb-6">
        {eyebrow}
      </div>
    )}
    <h1 className="text-3xl md:text-5xl leading-[1.05] tracking-tight font-medium">
      {title}
    </h1>
  </div>
);

export default PageHead;
